import {ImageEnhancer} from "../../components/my_tools/ai_enhancer/imageEnhancer";

interface IAiEnhancer{
    globalTextColor: string;
}
export const AiEnhancer: React.FC<IAiEnhancer> = ({globalTextColor}) => {
    return (
        <div className={`text-[${globalTextColor}]`}>
            <ImageEnhancer />
        </div>
    )
}
